import React, { PropTypes } from 'react';

const ReferralFormTextarea = (props) => {
  const { input, label, isRequired, meta: { touched, error } }  = props;
  const hasError = touched && error;

  return (
    <div>
      <label htmlFor={`${input.name}`}>
        {label}
        {isRequired && <span className="required"> *</span>}
      </label>
      <textarea
        {...input}
        className={hasError ? 'is-invalid-input' : ''}
        id={`${input.name}`}
      >
      </textarea>
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormTextarea.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  meta: PropTypes.object
};

export default ReferralFormTextarea;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormTextarea/index.js
 **/